export class Metadata {
    key: string;
    value: string;
}
